import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { AppointmentsReportPage } from '@/features/reports/appointments/appointments-report-page'
import { formatDocumentTitle } from '@/lib/document-title'

/** Reports › Appointments at `/$orgId/reports/appointments`, open to every report viewer. */
export const Route = createFileRoute('/_auth/$orgId/reports/appointments')({
  component: AppointmentsRoute,
})

function AppointmentsRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Appointments')}</title>
      </Helmet>
      <AppointmentsReportPage />
    </>
  )
}
